import {closeSearch} from "./search";

document.addEventListener('DOMContentLoaded', function () {
    registerMegamenuClick();
})

function registerMegamenuClick() {
    const menuItems = document.querySelectorAll('.list-menu-2024__item-has-children');
    if (menuItems.length === 0) return;
    document.body.prepend(megamenuBg());
    menuItems.forEach(menuItem => {
        menuItem.addEventListener('mouseenter', function(e){
            closeOpenedMenus();
            menuItem.classList.add('open');
            openMegamenuBg();
        });
        menuItem.addEventListener('mouseleave', function(e){
            closeOpenedMenus();
            closeMegamenuBg();
        });
    })
}

const megamenuBg = () => {
    const element = document.createElement('div');
    element.classList.add("mega-menu__bg");
    element.addEventListener('click', function () {
        closeOpenedMenus();
        closeMegamenuBg();
        closeSearch();
    })
    return element;
}

const closeOpenedMenus = () => {
    const openedMegamenus = document.querySelectorAll(".list-menu-2024__item-has-children.open");
    if (openedMegamenus.length === 0) return;
    openedMegamenus.forEach((openedMegamenu) => {
        openedMegamenu.classList.remove("open");
    });
}

export const openMegamenuBg = () => {
    const megamenuBg = document.querySelector('.mega-menu__bg');
    if (!megamenuBg) {
        return;
    }
    megamenuBg.classList.add('visible');
}

export const closeMegamenuBg = () => {
    const megamenuBg = document.querySelector('.mega-menu__bg');
    if (!megamenuBg) {
        return;
    }
    megamenuBg.classList.remove('visible');
}